let Config = {
	API_URL: "",
	JSON_HEADER: { "Content-Type": "application/json" },
	AMB: process.env.NODE_ENV,
	WSP_NUM: "56934855689",
	KEY: "PVvAX99miEVH76JKeTCGCW0nQ0PqduuD",
};

if (process.env.NODE_ENV === "production") {
	Config.API_URL= "";
}

if (process.env.NODE_ENV === "test") {
	Config.API_URL= "";
}

if (process.env.NODE_ENV === "development") {
	Config.API_URL= "";
}

export default Config;
